export default {
  debug: false,
  testing: false,
  brand: "pg",
  amtrustUrl: "https://marleyriskconsultants.com/AELclaim"
};
